








import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { openFilesDialog } from './utils';

@Component
export default class Files extends Vue {
    @Prop({ type: Boolean, required: false, default: true }) public multiple!: boolean;

    public mounted() {
        this.selectFiles();
    }

    public selectFiles() {
        openFilesDialog('*', this.multiple)
            .then((files) => {
                this.$emit('select', files);
            });
    }
}
